import React, {Component} from 'react';
import {GoogleLogo} from "../logos/GoogleLogo";
import {FacebookLogo} from "../logos/FacebookLogo";
import {SheetLogo} from "../logos/SheetLogo";
import {AnalyticsLogo} from "../logos/AnalyticsLogo";
import {TiktokLogo} from "../logos/TiktokLogo";
import {LinkedinLogo} from "../logos/LinkedinLogo";
import {LookerStudioLogo} from "../logos/LookerStudioLogo";
import {GSCLogo} from "../logos/GSCLogo";
import {DV360Logo} from "../logos/DV360Logo";
import {MercadoAdsLogo} from "../logos/MercadoAdsLogo";
import {LOOKER_CC_CHANNEL, DATA_NODE_CHANNEL, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, KLAVIYO_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL, SEARCH_CONSOLE_CHANNEL, DV360_CHANNEL, ESCALAFY_CHANNEL, MERCADO_ADS_CHANNEL} from "./channels";
import {ShopifyLogo} from "../logos/ShopifyLogo";
import {TiendaNubeLogo} from "../logos/TiendaNubeLogo";
import {DataNodeLogo} from "../logos/DataNodeLogo";
import {KlaviyoLogo} from "../logos/KlaviyoLogo";
import {WooCommerceLogo} from "../logos/WooCommerceLogo";
import {VtexLogo} from "../logos/VtexLogo";
import {EscalafyLogo} from "../logos/EscalafyLogo";

export class ChannelLogo extends Component {

    getHSpace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;

        if (this.props.channel === LOOKER_CC_CHANNEL)
            return 5;

        return 10;
    }

    getVSpace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;

        if (this.props.channel === LOOKER_CC_CHANNEL)
            return 0;

        return 10;
    }

    useOld() {
        if(this.props.useOld !== undefined)
            return this.props.useOld;
        return true;
    }

    marginLeft() {
        if(this.props.marginLeft !== undefined)
            return this.props.marginLeft;

        if (this.props.channel === 'GOOGLE')
            return 0;


        if (this.props.channel === 'FACEBOOK') {
            return '5px';
        }

        if (this.props.channel === 'SHEET') {
            return 0;
        }
        if (this.props.channel === 'ANALYTICS') {
            return 0;
        }

        if (this.props.channel === SEARCH_CONSOLE_CHANNEL) {
            return 0;
        }

        if (this.props.channel === 'TIKTOK') {
            return '5px';
        }

        if (this.props.channel === 'LINKEDIN') {
            return 0;
        }

        if (this.props.channel === DV360_CHANNEL) {
            return 0;
        }

        if (this.props.channel === MERCADO_ADS_CHANNEL) {
            return 0;
        }

        if (this.props.channel === LOOKER_CC_CHANNEL) {
            return '5px';
        }
        if (this.props.channel === DATA_NODE_CHANNEL) {
            return 0;
        }

        if (this.props.channel === SHOPIFY_CHANNEL) {
            return '5px';
        }

        if (this.props.channel === TIENDA_NUBE_CHANNEL) {
            return '5px';
        }

        if (this.props.channel === KLAVIYO_CHANNEL) {
            return '5px';
        }

        if (this.props.channel === WOOCOMMERCE_CHANNEL) {
            return '5px';
        }

        if (this.props.channel === VTEX_CHANNEL) {
            return '5px';
        }

        if (this.props.channel === ESCALAFY_CHANNEL) {
            return '5px';
        }
    }

    padding() {
        if(this.props.padding !== undefined)
            return this.props.padding;

        if (this.props.channel === 'GOOGLE')
            return 0;


        if (this.props.channel === 'FACEBOOK') {
            return 0;
        }

        if (this.props.channel === 'SHEET') {
            return '4px';
        }
        if (this.props.channel === 'ANALYTICS') {
            return '4px';
        }

        if (this.props.channel === SEARCH_CONSOLE_CHANNEL) {
            return '2px';
        }

        if (this.props.channel === 'TIKTOK') {
            return 0;
        }

        if (this.props.channel === 'LINKEDIN') {
            return 0;
        }

        if (this.props.channel === DV360_CHANNEL) {
            return 0;
        }

        if (this.props.channel === MERCADO_ADS_CHANNEL) {
            return 0;
        }

        if (this.props.channel === LOOKER_CC_CHANNEL) {
            return 0;
        }

        if (this.props.channel === DATA_NODE_CHANNEL) {
            return 0;
        }
    }

    getHeight() {
        if(this.props.height)
            return this.props.height;
        return null;
    }

    getWidth() {
        if(this.props.width)
            return this.props.width;
        return null;
    }

    render() {
        if (this.props.channel === 'GOOGLE') {
            return <GoogleLogo useOld={this.useOld()} styles={{marginLeft: this.marginLeft()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()} />
        }

        if (this.props.channel === 'FACEBOOK') {
            return <FacebookLogo styles={{marginLeft: this.marginLeft()}} hspace={this.getHSpace()} vspace={this.getVSpace()}  width={this.getWidth()} height={this.getHeight()} />
        }

        if (this.props.channel === 'SHEET') {
            let style = this.props.styles !== undefined ? this.props.styles : {};
            style = {marginLeft:this.marginLeft(), padding: this.padding(), ...style};
            return <SheetLogo styles={style} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()} />
        }
        if (this.props.channel === 'ANALYTICS') {
            return <AnalyticsLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === SEARCH_CONSOLE_CHANNEL) {
            return <GSCLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === 'TIKTOK') {
            return <TiktokLogo useLogoImageWithPadding={this.props.useLogoImageWithPadding} styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === 'LINKEDIN') {
            return <LinkedinLogo renderVeryColoredVersion={this.props.renderVeryColoredVersion} useLogoImageWithPadding={this.props.useLogoImageWithPadding} styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === DV360_CHANNEL) {
            return <DV360Logo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === MERCADO_ADS_CHANNEL) {
            return <MercadoAdsLogo renderVeryColoredVersion={this.props.renderVeryColoredVersion} styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === SHOPIFY_CHANNEL) {
            return <ShopifyLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === TIENDA_NUBE_CHANNEL) {
            return <TiendaNubeLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === KLAVIYO_CHANNEL) {
            return <KlaviyoLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === WOOCOMMERCE_CHANNEL) {
            return <WooCommerceLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === VTEX_CHANNEL) {
            return <VtexLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === ESCALAFY_CHANNEL) {
            return <EscalafyLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === LOOKER_CC_CHANNEL) {
            return <LookerStudioLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }

        if (this.props.channel === DATA_NODE_CHANNEL) {
            return <DataNodeLogo styles={{marginLeft:this.marginLeft(), padding: this.padding()}} hspace={this.getHSpace()} vspace={this.getVSpace()} width={this.getWidth()} height={this.getHeight()}/>
        }
    }
}
